import type { FaireProductEntity } from "../../entity_types/product";

export const p_c4za2rhhcq: FaireProductEntity = {
  token: "p_c4za2rhhcq",
  type: "product",
  name: "Colombo Ramen / Noodle Bowl / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/8beab3118675d2d612195c9d2ddab6bc3f2a35510caab5dde378d207f710d57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/215b407729f38da2a462100f09729cbf845ac8d4ea3fbe409695823b92bde186.jpeg",
    "https://cdn.faire.com/fastly/7ec77a2152a4f740e5d38f2dc0aa1495e27a1175f918308c2228e1486ed8d337.jpeg",
    "https://cdn.faire.com/fastly/9df652f2fabc7b278405e83e713a4f6250e3fee4714ebffed778a72b0899e31a.jpeg",
  ],
  priceDollars: 40,
  description:
    "COLOMBO is a sculptural dinnerware range inspired by our love of sharing the table and feasting with friends and family.\n\nThe COLOMBO Ramen Bowl extends this spirit into global flavours and culinary traditions. Its generous form is ideal for noodle broths, vibrant curries, hearty stews or salads from around the world.\n\nCrafted from high-fired coloured porcelain in earthy tones, with a tactile unglazed exterior and smooth, glazed interior, it’s made to be enjoyed every day and to last a lifetime.\n\n• Material: Porcelain\n• Size: Ø18 x 9cm / Ø7” x 3.5”\n• Set of 2",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:33.574Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
